export function SectionHeader(prop: { title: string }) {
    return (
        <p id={prop.title} style={{ fontSize: 30, marginBottom: 20, paddingTop: 140, fontFamily: "Tilt Neon" }}>
            {prop.title}
        </p>
    )
}